import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-30" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "fs-18 mb-40 text-title" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ps-0 ls-1"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
}
const _hoisted_12 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0" }
const _hoisted_13 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_14 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_16 = { class: "quantity-cell" }
const _hoisted_17 = {
  key: 0,
  class: "d-block text-danger mt-2"
}
const _hoisted_18 = { class: "shadow-none lh-1" }
const _hoisted_19 = ["value", "onChange"]
const _hoisted_20 = { value: "add" }
const _hoisted_21 = { value: "subtract" }
const _hoisted_22 = { class: "shadow-none lh-1 text-end pe-0" }
const _hoisted_23 = { class: "button-group style-two ms-auto d-flex flex-wrap align-items-center" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["alt"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  colspan: "6",
  class: "text-center py-4 text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t("adjustment_page.selected_products_for_adjustment")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("adjustment_page.product")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("adjustment_page.product_code")), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("adjustment_page.available_stock")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("adjustment_page.quantity")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("adjustment_page.type")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("adjustment_page.delete")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: product.id
              }, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(product.name), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(product.code), 1),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge fw-semibold fs-14", product.availableStock > 0 ? 'badge-success-soft' : 'badge-danger-soft'])
                  }, _toDisplayString(product.availableStock), 3)
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_QuantityCounter, {
                      modelValue: product.quantity,
                      "onUpdate:modelValue": ($event: any) => (_ctx.$emit('update-quantity', index, $event))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    (product.adjustmentType === 'subtract' && product.quantity > product.availableStock)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.$t("adjustment_page.quantity_exceeds_available_stock")), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("select", {
                    value: product.adjustmentType,
                    class: "select-cat fs-14 fw-medium border-0 bg-transparent",
                    onChange: ($event: any) => (_ctx.$emit('update-type', index, ($event.target as HTMLSelectElement).value))
                  }, [
                    _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("adjustment_page.addition")), 1),
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("adjustment_page.deduction")), 1)
                  ], 40, _hoisted_19)
                ]),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("a", {
                      class: "delete-btn cursor-pointer",
                      onClick: ($event: any) => (_ctx.$emit('remove', index))
                    }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: _ctx.$t('adjustment_page.delete')
                      }, null, 8, _hoisted_25)
                    ], 8, _hoisted_24)
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.products.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$t("adjustment_page.no_products_selected")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}